import Section from "@/components/Section";
import { Box, CardMedia, Container, Typography, useTheme } from "@mui/material";
import CompareSection from "./components/CompareSection";
import MapIcon from "@/assets/icons/compare-devices/map.svg";
import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";

const CompareDevices = () => {
  const theme = useTheme();
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <Section
        pt={{ xs: 0, lg: 8 }}
        pb={{ xs: 5, md: 15 }}
        sectionSx={{ position: "relative", overflow: "hidden" }}
      >
        <CardMedia
          component="img"
          image={MapIcon}
          alt="map"
          sx={{
            width: { xs: "100%", md: "714px" },
            height: "auto",
            position: "absolute",
            zIndex: "0",
            top: { xs: "-24px", md: "-36px" },
            right: "0px",
          }}
        />
        <Box sx={{ position: "relative", zIndex: "1" }}>
          <Typography
            color={theme.palette.grey[800]}
            variant="h1"
            sx={{
              paddingBottom: "16px",
              textAlign: "center",
            }}
          >
            Compare devices
          </Typography>
          <Typography
            variant="subtitle1"
            component="p"
            color={theme.palette.grey[600]}
            sx={{
              textAlign: "center",
              marginBottom: "64px",
            }}
          >
            Choose device to suit your business.
          </Typography>
          <CompareSection />
          <Box
            sx={{
              padding: "10px 16px",
              marginTop: "8px",
            }}
          >
            <Typography
              sx={{
                fontWeight: "600",
                color: theme.palette.primary.main,
                fontSize: "0.875rem !important",
              }}
            >
              *Available on select plans
            </Typography>
          </Box>
        </Box>
      </Section>
    </>
  );
};

export default CompareDevices;
